import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import axios from 'axios';

/**
 * Self-service "change my password" modal for the logged-in user.
 *
 * Posts to /api/auth/change-password, which requires the current
 * password. Reusable across surfaces — the admin dashboard mounts it
 * today; the customer / technician shells can mount the same
 * component unchanged.
 */
function ChangePasswordModal({ onClose }) {
  const [current, setCurrent] = useState('');
  const [next, setNext] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState(null);
  const [saving, setSaving] = useState(false);
  const [done, setDone] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    if (next !== confirm) {
      setError('הסיסמה החדשה ואימותה אינם זהים');
      return;
    }
    setSaving(true);
    try {
      await axios.post('/api/auth/change-password', {
        current_password: current,
        new_password: next,
      });
      setDone(true);
    } catch (err) {
      setError(err.response?.data?.error || 'שגיאה בעדכון הסיסמה');
    } finally {
      setSaving(false);
    }
  };

  return createPortal(
    <>
      <div className="modal-overlay" onClick={onClose} />
      <form
        className="modal"
        onSubmit={handleSubmit}
        style={{
          position: 'fixed',
          top: '50%', left: '50%',
          transform: 'translate(-50%, -50%)',
          zIndex: 101,
          width: 'min(420px, calc(100vw - 24px))',
        }}
      >
        <h2>שינוי סיסמה</h2>

        {done ? (
          <>
            <div style={{
              background: '#ecfdf5', border: '1px solid #a7f3d0',
              color: '#047857', padding: '0.6rem 0.85rem',
              borderRadius: '6px', fontSize: '0.85rem',
            }}>
              הסיסמה עודכנה בהצלחה.
            </div>
            <div className="modal-actions">
              <button type="button" className="btn btn-primary" onClick={onClose}>
                סגירה
              </button>
            </div>
          </>
        ) : (
          <>
            <div className="form-group">
              <label>סיסמה נוכחית</label>
              <input
                type="password"
                value={current}
                onChange={e => setCurrent(e.target.value)}
                required
                autoFocus
              />
            </div>
            <div className="form-group">
              <label>סיסמה חדשה</label>
              <input
                type="password"
                value={next}
                onChange={e => setNext(e.target.value)}
                required
              />
            </div>
            <div className="form-group">
              <label>אימות סיסמה חדשה</label>
              <input
                type="password"
                value={confirm}
                onChange={e => setConfirm(e.target.value)}
                required
              />
            </div>
            <p style={{ color: '#6b7280', fontSize: '0.78rem', margin: '0 0 0.25rem' }}>
              הסיסמה חייבת לכלול לפחות 8 תווים וספרה אחת.
            </p>

            {error && (
              <div style={{
                background: '#fef2f2', border: '1px solid #fecaca',
                color: '#b91c1c', padding: '0.5rem 0.75rem',
                borderRadius: '6px', marginTop: '0.5rem', fontSize: '0.8rem',
              }}>
                {error}
              </div>
            )}
            <div className="modal-actions">
              <button type="submit" className="btn btn-primary" disabled={saving}>
                {saving ? 'שומר...' : 'עדכן סיסמה'}
              </button>
              <button type="button" className="btn btn-secondary" onClick={onClose} disabled={saving}>
                ביטול
              </button>
            </div>
          </>
        )}
      </form>
    </>,
    document.body
  );
}

export default ChangePasswordModal;
